(function () {
    var exportCitation = {
        $toggle: $('#citation-format'),
        $target: $('.csl-response'),
        $wrapper: null,
        $multiToggle: $('.issue-Item__checkbox:checked'), // overwrite its value based on product html structure
        dois: null,
        $trigger: null,
        response: null,
        selectCiteStyle: null,
        responseFormat: {},
        citationLimited: false,
        citationLimitNumber: 0,
        loadingAdditionalInfo: '',

        init: function () {
            exportCitation.control();
        },

        control: function (url, params, dataType) {
            $(document).on('click', '[data-target="#exportCitation"]', function () {
                exportCitation.$trigger = $(this);
                exportCitation.resetPopup(exportCitation.$trigger);
                exportCitation.dois = exportCitation.collectDois(exportCitation.$trigger).toString();
                exportCitation.loadCiteProc(exportCitation.$toggle);
            });

            $(document).on('change', '#citation-format', function () {
                exportCitation.loadCiteProc($(this));
            });
        },
        getWarningMessage: function (message) {
            return message;
        },
        performServerSideAjax: function (url, params, selectCiteStyle) {
            $.ajax({
                url: url,
                data: params,
                async: true,
                success: function (response) {
                    exportCitation.response = response;
                    exportCitation.responseFormat[selectCiteStyle] = exportCitation.response;
                    exportCitation.setContent(exportCitation.responseFormat[selectCiteStyle].content);
                    exportCitation.downloadCiteProc();
                },
            });
        },
        collectDois: function ($el) {
            var doisArray = [];
            var multiDois = false;
            if ($el.hasClass('export-citation')) {
                multiDois = true;
            }

            if (multiDois) {
                exportCitation.$multiToggle = $('.issue-Item__checkbox:checked');
                exportCitation.$multiToggle.each(function () {
                    const $this = $(this);
                    const doiValue = $this.attr('name') === 'doi' ? $this.val() : $this.attr('name');
                    doisArray.push(doiValue);
                });
            } else {
                $el.find('[name="doiVal"]').each(function () {
                    doisArray.push($(this).val());
                });
            }

            return doisArray;
        },
        loadCiteProc: function ($el) {
            exportCitation.selectCiteStyle = $el.val();
            const selectedFormat = $('[value=' + exportCitation.selectCiteStyle + ']').data('format'),
                targetCustomCSLFIle = 'custom-' + exportCitation.selectCiteStyle;
            $('#export-warning').empty();
            exportCitation.$wrapper = $el.closest('.csl-wrapper');
            exportCitation.$target = exportCitation.$wrapper.find('.csl-response');

            if (exportCitation.selectCiteStyle) {
                exportCitation.$wrapper
                    .find('.copy__btn, .download__btn')
                    .addClass('disabled')
                    .parent('li')
                    .css('cursor', '');
                exportCitation.$wrapper.find('#citation-format').attr('disabled', 'disabled');
                //add spinner
                const loadingText = 'Loading ' + exportCitation.loadingAdditionalInfo + '... ';
                exportCitation.$target.html('<span>' + loadingText + '</span>');

                const action_server = '/action/exportCiteProcCitation';
                // var action_server = '/specs/ux3/widgets/export-citations/js/dummy-csl-metaData.json'; // dummy for UX3 testing
                //var action_server = '/specs/products/acm/widgets/export-citations/js/dummy-csl-metaData.json'; // dummy for ACM testing

                const params = exportCitation.setParams(targetCustomCSLFIle, selectedFormat);

                if (typeof exportCitation.responseFormat[exportCitation.selectCiteStyle] !== 'undefined') {
                    exportCitation.setContent(exportCitation.responseFormat[exportCitation.selectCiteStyle].content);
                    exportCitation.downloadCiteProc();
                } else {
                    exportCitation.performServerSideAjax(action_server, params, exportCitation.selectCiteStyle);
                }

                exportCitation.$wrapper.find('[name="dois"]').val(exportCitation.dois);
                exportCitation.$wrapper.find('[name="format"]').val(selectedFormat);
            }
        },
        setParams: function (targetCustomCSLFIle, selectedFormat) {
            return {dois: exportCitation.dois, targetFile: targetCustomCSLFIle, format: selectedFormat};
        },
        resetPopup: function ($el) {
            exportCitation.$target.html('');
            exportCitation.responseFormat = {};
            exportCitation.$toggle.prop('selectedIndex', 0);
            const $modal = $($el.attr('data-target'));
            $modal.find('.copy__btn, .download__btn').addClass('disabled').parent('li').css('cursor', '');
            $modal.find('#citation-format').attr('disabled', 'disabled');
        },

        setContent: function (content) {
            exportCitation.$target.html(content);
            exportCitation.$wrapper.find('[name="content"]').val(exportCitation.$target.text());
            exportCitation.$wrapper
                .find('.copy__btn, .download__btn')
                .removeClass('disabled')
                .parent('li')
                .css('cursor', 'pointer');
            exportCitation.$wrapper.find('#citation-format').removeAttr('disabled');
            if (exportCitation.responseFormat[exportCitation.selectCiteStyle].warning) {
                exportCitation.$wrapper
                    .find('#export-warning')
                    .html(
                        exportCitation.getWarningMessage(
                            exportCitation.responseFormat[exportCitation.selectCiteStyle].warning
                        )
                    );
            }
        },
        downloadCiteProc: function () {
            let $el = $('.download__btn'),
                downloadContainer = exportCitation.$target,
                downloadData = '';

            if (downloadContainer.is('.csl-response')) {
                if (exportCitation.$target.find('.csl-right-inline').length) {
                    downloadContainer = exportCitation.$target.find('.csl-right-inline');
                    downloadData = downloadContainer.html();

                    if (/<\/?[a-z][\s\S]*>/i.test(downloadContainer.html())) {
                        downloadData = downloadContainer.text();
                    }
                } else if (exportCitation.$target.find('.csl-entry').length) {
                    downloadContainer = exportCitation.$target.find('.csl-entry');
                    downloadData = downloadContainer.html();
                    if (/<\/?[a-z][\s\S]*>/i.test(downloadContainer.html())) {
                        downloadData = downloadContainer.text();
                    }
                }

                if (downloadContainer.length > 1) {
                    let downloadMultiText = '';
                    downloadContainer.each(function () {
                        let $this = $(this);

                        if (/<\/?[a-z][\s\S]*>/i.test($this.html())) {
                            downloadMultiText += $this.text() + '\n\n';
                        } else {
                            downloadMultiText += $this.html() + '\n\n';
                        }
                    });
                    downloadData = downloadMultiText;
                }
            }

            downloadData = exportCitation.additionalDownloadDataFormat(downloadData);

            $el.attr(
                'href',
                'data:' +
                    exportCitation.responseFormat[exportCitation.selectCiteStyle].contentType +
                    ';charset=utf-8,' +
                    encodeURIComponent(downloadData)
            );
            $el.attr(
                'download',
                exportCitation.responseFormat[exportCitation.selectCiteStyle].fileName +
                    '.' +
                    exportCitation.responseFormat[exportCitation.selectCiteStyle].suffix
            );
        },
        additionalDownloadDataFormat: function (downloadData) {
            return downloadData;
        },
    };

    UX.exportCitation = exportCitation; // add to global namespace
})();
